/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Action, Store } from 'fierry/flux';

import * as Util from 'shared/client/url/util';


const Actions =
{
  Reconcile:    new Action(),

  ReplaceState: new Action(),
  PushState:    new Action(),
  PopState:     new Action(),
};


const InitialState = { permanent: [ Util.getDefaultState() ], future: [], temporary: null };


const reconcile = (state, { history, id }) =>
{
  const { temporary } = state;

  state = moveHistory(loadHistory(state, history), id);

  return temporary ? pushState(state, temporary) : state;
}


const moveHistory = (state, id) =>
{
  let permanent = [...state.permanent, ...state.future];

  let future = permanent.splice(Util.indexOf(permanent, id) + 1);

  return { ...state, permanent, future };
}


const loadHistory = (state, history) =>
{
  const { id } = Util.getPermanent(state);

  let { permanent, future } = state;

  for (const entry of history)
  {
    if (entry.id <= id)
    {
      permanent = loadHistoryEntry(entry, permanent);
    }
    else
    {
      future = loadHistoryEntry(entry, future);
    }
  }

  return { ...state, permanent, future };
}


const loadHistoryEntry = (lhs, collection) =>
{
  if (Util.indexOf(collection, lhs.id) === -1)
  {
    collection = [ ...collection, lhs ];
  }

  collection.sort((lhs, rhs) => lhs.id - rhs.id);

  return collection;
}


const replaceState = (state, action) =>
{
  const permanent = Util.popPermanent(state);

  return replaceHistoryState({ permanent: [ ...permanent, Util.getFutureState(state, action) ], future: [], temporary: null });
}


const replaceHistoryState = (state) =>
{
  window.history.replaceState(Util.getSessionState(state), '', Util.getSessionURL(state));

  return state;
}


const pushState = (state, action) =>
{
  const { permanent } = state;

  return pushHistoryState({ permanent: [ ...permanent, Util.getFutureState(state, action) ], future: [], temporary: null });
}


const pushHistoryState = (state) =>
{
  window.history.pushState(Util.getSessionState(state), '', Util.getSessionURL(state));

  return state;
}


const popState = (state, { level }) =>
{
  const popCount = Util.getPopCountBefore(state, level);

  return popHistoryState({ ...state, temporary: Util.getPermanent(state, popCount) }, popCount);
}


const popHistoryState = (state, popCount) =>
{
  if (popCount < state.permanent.length - 1)
  {
    ++popCount;
  }

  window.history.go(- popCount)

  return state;
}


export default new Store (InitialState, Actions,
[
  [Actions.Reconcile,    reconcile],

  [Actions.ReplaceState, replaceState],
  [Actions.PushState,    pushState],
  [Actions.PopState,     popState],
]);
